var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "188px",
    height: "151px",
    viewBox: "0 0 188 151",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Upload") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "97.0872471%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6DC79",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E7B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-2",
    cx: 4.8,
    cy: 99.8,
    r: 4.8
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-31.3%",
    y: "-31.2%",
    width: "162.5%",
    height: "162.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.241315128   0 0 0 0 0.429347826   0 0 0 0 0.0590680508  0 0 0 0.497268357 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-4",
    cx: 156.8,
    cy: 60.8,
    r: 4.8
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-31.3%",
    y: "-31.2%",
    width: "162.5%",
    height: "162.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.241315128   0 0 0 0 0.429347826   0 0 0 0 0.0590680508  0 0 0 0.497268357 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-6",
    cx: 53.8,
    cy: 28.8,
    r: 4.8
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-31.3%",
    y: "-31.2%",
    width: "162.5%",
    height: "162.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.241315128   0 0 0 0 0.429347826   0 0 0 0 0.0590680508  0 0 0 0.497268357 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110,55.062 C110,24.686 85.376,0.062 55,0.062 C24.624,0.062 0,24.686 0,55.062 C0,73.854 9.43,90.436 23.81,100.356 L86.192,100.356 C100.57,90.436 110,73.854 110,55.062 Z",
    id: "path-8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Zeplin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy",
    transform: "translate(-2120.000000, -68.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Upload",
    transform: "translate(2122.000000, 68.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-10",
    fill: "url(#linearGradient-1)",
    cx: 183.5,
    cy: 107.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-12",
    fill: "url(#linearGradient-1)",
    cx: 132.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-8",
    fill: "url(#linearGradient-1)",
    cx: 21.5,
    cy: 24.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-20"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-27"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-29"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-7)",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-26",
    fill: "#FFFFFF",
    cx: 42.8,
    cy: 109.8,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-28",
    fill: "#FFFFFF",
    cx: 53.8,
    cy: 62.8,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-30",
    fill: "#FFFFFF",
    cx: 121.8,
    cy: 126.8,
    r: 1.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "spaark_finance_mango_presentation",
    transform: "translate(33.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path",
    transform: "translate(0.000000, 0.320000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#D6E8C5",
    fillRule: "nonzero",
    xlinkHref: "#path-8"
  }), /*#__PURE__*/React.createElement("polyline", {
    stroke: "#4C8218",
    strokeWidth: 3,
    fill: "#D6E8C5",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-9)",
    transform: "translate(36.498000, 94.858000) scale(-1, 1) rotate(-90.000000) translate(-36.498000, -94.858000) ",
    points: "72.086 109.026 72.086 66.68 0.91 66.68 0.91 123.036 72.086 123.036 72.086 115.026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,71.68 L52.5,71.68 L52.5,108.68 L20.5,108.68 L20.5,71.68 Z",
    id: "Rectangle",
    stroke: "#4C8218",
    strokeWidth: 3,
    fill: "#FFFFFF",
    strokeDasharray: "6,5",
    mask: "url(#mask-9)",
    transform: "translate(36.500000, 90.180000) rotate(-180.000000) translate(-36.500000, -90.180000) "
  })), /*#__PURE__*/React.createElement("line", {
    x1: 12.632,
    y1: 100.5,
    x2: 94.72,
    y2: 100.676,
    id: "Path",
    stroke: "#4C8218",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.75,
    y1: 107.148,
    x2: 78.25,
    y2: 107.148,
    id: "Path",
    stroke: "#4C8218",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    stroke: "#345712",
    strokeWidth: 3,
    fill: "#FFFFFF",
    strokeLinejoin: "round",
    points: "83 64 118.784823 64 126 72.0540322 126 117 83 117"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(66.000000, 85.000000) scale(-1, 1) translate(-66.000000, -85.000000) translate(55.000000, 74.000000)",
    stroke: "#345712"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    strokeWidth: 1.2,
    fill: "#345712",
    strokeLinejoin: "round",
    transform: "translate(18.500000, 19.000000) scale(1, -1) translate(-18.500000, -19.000000) ",
    points: "18.5 16 22 22 15 22"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle-Copy",
    strokeWidth: 1.2,
    fill: "#345712",
    strokeLinejoin: "round",
    transform: "translate(3.500000, 4.000000) scale(-1, -1) rotate(90.000000) translate(-3.500000, -4.000000) ",
    points: "3.5 1 7 7 0 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,4 C12.372583,4 7,9.372583 7,16",
    id: "Oval",
    strokeWidth: 2.4,
    transform: "translate(13.000000, 10.000000) scale(-1, 1) translate(-13.000000, -10.000000) "
  })), /*#__PURE__*/React.createElement("line", {
    x1: 92.52,
    y1: 82.5,
    x2: 117.48,
    y2: 82.5,
    id: "Line-3",
    stroke: "#979797",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.52,
    y1: 92.5,
    x2: 117.48,
    y2: 92.5,
    id: "Line-3-Copy",
    stroke: "#979797",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.52,
    y1: 102,
    x2: 117.48,
    y2: 102,
    id: "Line-3-Copy-2",
    stroke: "#979797",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBg);
export default __webpack_public_path__ + "static/media/upload_bg.54b74471ae6baa0182582ed7cd9e00b1.svg";
export { ForwardRef as ReactComponent };